<template>
  <div>
    <a-drawer
      :zIndex="2000"
      class="create-device-group"
      wrapClassName="drawer"
      placement="right"
      :closable="false"
      :visible="visible"
      :afterVisibleChange="render"
      @close="$emit('close')"
    >
      <template v-if="loaded">
        <DeviceGroupsEdit :preloadedDevices="preloadedDevices" @close="$emit('close')" />
      </template>
    </a-drawer>
  </div>
</template>

<script>
import DeviceGroupsEdit from '@/components/pages/device-groups/DeviceGroupsEdit.vue'
import Drawer from 'ant-design-vue/lib/drawer'
import 'ant-design-vue/lib/drawer/style/index.css'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    preloadedDevices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  methods: {
    render() {
      this.loaded = true
    },
  },
  components: {
    DeviceGroupsEdit,
    'a-drawer': Drawer,
  },
}
</script>
